import { DefaultTheme } from "styled-components";
import { bullish as bullishAlert } from "../components/Alert/theme";
import { bullish as bullishCard } from "../components/Card/theme";
import { bullish as bullishRadio } from "../components/Radio/theme";
import { bullish as bullishToggle } from "../components/Toggle/theme";
import { bullish as bullishNav } from "../widgets/Menu/theme";
import { bullish as bullishModal } from "../widgets/Modal/theme";
import { bullish as bullishTooltip } from "../components/Tooltip/theme";
import base from "./base";
import { BullishColors } from "./colors";

const bullishTheme: DefaultTheme = {
  ...base,
  isDark: false,
  isBearish: false,
  isBullish: true,
  alert: bullishAlert,
  colors: BullishColors,
  card: bullishCard,
  toggle: bullishToggle,
  nav: bullishNav,
  modal: bullishModal,
  radio: bullishRadio,
  tooltip: bullishTooltip,
};

export default bullishTheme;
